import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

import { Logo } from "@/components/logo";

/** Split layout for login / register / verify: form on the left, brand photo panel on desktop. */
export function AuthShell({ children, step, backTestId, onBack }) {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen bg-background">
      <div className="flex w-full flex-col lg:w-[56%]">
        <div className="flex h-16 items-center gap-2 px-4 md:px-8">
          <button data-testid={backTestId} aria-label="Go back" onClick={onBack ?? (() => navigate(-1))} className="flex h-11 w-11 items-center justify-center rounded-full hover:bg-[#F4EBE6]">
            <ChevronLeft className="h-6 w-6" />
          </button>
          {step ? <span className="text-[13px] font-medium text-muted-foreground">{step}</span> : null}
        </div>
        <div className="fade-up mx-auto w-full max-w-lg flex-1 px-6 pb-12 pt-4">{children}</div>
      </div>
      <div className="relative hidden flex-1 lg:block">
        <img src="/images/landing.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2A2727] via-[rgba(42,39,39,0.35)] to-transparent" />
        <div className="absolute inset-x-10 bottom-10">
          <Logo inverse />
          <p className="mt-3 font-display text-3xl text-[#FDFBF7]">Connect with Purpose. Find Your Match.</p>
        </div>
      </div>
    </div>
  );
}
